module.exports = __webpack_public_path__ + "img/meal.c1a35f61.png";